import { 
	RECEIVE_PHOTOS,
	GET_FAVORITES,
	ADD_PHOTO_TO_FAVORITES
} from '../actions';

const photos = (state = {photos: [], favorites: []}, action) => {
	switch (action.type) {

		case GET_FAVORITES:

			let currentFavorites = JSON.parse(localStorage.getItem('flickrPhotosAppReact'));
			if (!currentFavorites) {
				currentFavorites = [];
			}

			return Object.assign({}, state, {
				favorites: currentFavorites
			});

		case ADD_PHOTO_TO_FAVORITES:

		    if (!localStorage.getItem('flickrPhotosAppReact')) {
      			localStorage.setItem('flickrPhotosAppReact', JSON.stringify([{
        			title: action.title,
        			url: action.url
      			}]));
    		} else {
      			let currentFavs = JSON.parse(localStorage.getItem("flickrPhotosAppReact"));
      			currentFavs.push({
        			title: action.title,
        			url: action.url
      			});
      			localStorage.setItem('flickrPhotosAppReact', JSON.stringify(currentFavs));
			}

			let favorites = JSON.parse(localStorage.getItem('flickrPhotosAppReact'));
			if (!favorites) {
				favorites = [];
			}

			return Object.assign({}, state, {
				favorites: favorites
			});

		case RECEIVE_PHOTOS:
			
			let photos = state.photos.slice();
			if (action.isNewSearch) {
				photos = [];
			}

			let jsonRes = action.photosJson.photos.photo;
			
      		for (let i = 0; i < jsonRes.length; i++) {
        		let farm = jsonRes[i].farm;
        		let id = jsonRes[i].id;
        		let secret = jsonRes[i].secret;
        		let server = jsonRes[i].server;
        		let title = jsonRes[i].title;
        		let photoUrl = 'https://farm' + farm + '.staticflickr.com/' + server + '/' + id + '_' + secret + '.jpg';
        		photos.push({ url: photoUrl, title: title });
        	}
			
			return Object.assign({}, state, {
				photos: photos,
				page: action.photosJson.photos.page,
				totalPages: action.photosJson.photos.pages
			});

		default:
			return state;
	}
};

export { photos };


/** WEBPACK FOOTER **
 ** ./src/flickr-redux/reducers/photosActionReducers.js
 **/